import type { ContentPage } from "@/lib/content/types";

export const whatsapp: ContentPage = {
  slug: "omni-channels/whatsapp",
  template: "hrmsFeature",
  seo: {
    title: "WhatsApp CRM - Chat With Customers on WhatsApp | GetBiz CRM",
    description:
      "Connect WhatsApp to GetBiz CRM and chat with customers from a shared inbox. Automate replies, capture leads, and keep every conversation on the contact record.",
    keywords: [
      "WhatsApp CRM",
      "WhatsApp Business API CRM",
      "WhatsApp inbox",
      "WhatsApp automation",
      "WhatsApp lead capture",
      "whatsapp customer support",
    ],
    ogImage: "/assets/data/seoimages/whatsapp.webp",
  },
  leaf: {
    hero: {
      caption: "WhatsApp",
      title: "Sell and Support on the App Customers Live In",
      description:
        "Bring WhatsApp into GetBiz CRM — a shared team inbox, automated replies, lead capture and templates — with every chat saved to the customer's record.",
      h1: "caption",
    },
    split: {
      title: "WhatsApp, Managed by Your Whole Team",
      bullets: [
        { title: "Shared Inbox", description: "Your team replies from one WhatsApp inbox." },
        { title: "Automated Replies", description: "Trigger messages from workflows and cadences." },
        { title: "Lead Capture", description: "Turn chats into CRM leads automatically." },
        { title: "Templates", description: "Approved, reusable message templates." },
      ],
      image: "/assets/images/img/product/crm/whatsapp-lead-image.webp",
      imageAlt: "GetBiz CRM WhatsApp",
    },
    cardsHeading: { title: "More Omni Channels", description: "WhatsApp works with the rest of GetBiz CRM omni-channel." },
    cards: [
      { title: "SMS", href: "/crm-software/omni-channels/sms/", description: "Reach customers by text as well.", image: "/assets/images/img/product/crm/sms.webp", imageAlt: "CRM SMS" },
      { title: "Social Media", href: "/crm-software/omni-channels/social-media/", description: "Handle social DMs in the same inbox.", image: "/assets/images/img/product/crm/social-media.webp", imageAlt: "CRM social media" },
      { title: "Live Chat", href: "/crm-software/omni-channels/live-chat/", description: "Chat with website visitors too.", image: "/assets/images/img/product/crm/live-chat.webp", imageAlt: "CRM live chat" },
      { title: "Email", href: "/crm-software/omni-channels/email/", description: "Follow up with tracked email.", image: "/assets/images/img/product/crm/email.webp", imageAlt: "CRM email" },
    ],
    testimonials: { title: "Meet customers on WhatsApp", description: "See why teams use WhatsApp with GetBiz CRM." },
    bookDemoTitle: "Add WhatsApp to your CRM.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "whatsapp-crm-for-business, whatsapp-business-api-guide",
    metaKey: "whatsapp",
  },
  sections: [],
};
